module.exports = __webpack_public_path__ + "img/1x.3d0eec4.jpg";